// debugging helper functions
// allowed level values are trace, debug, log, warn, error
// set window.loggerFactory.setLogWarnings(LEVEL)
// LEVEL:
// TRACE: log everything
// DEBUG : everything but trace
// INFO : everything but DEBUG and TRACE
// WARN : error and warn only
// ERROR : errors only
// LEVEL 8 will turn everything off
export default {
  methods: {
    elog(level, format, ...args)  {
      // console.log(this.$options)
      var d = new Date()
      var str = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds() + ' '
      format = str + '({}) ' + format
      // let comp = this.$options._componentTag ? this.$options._componentTag : 'App'
      let comp = this.$options.name ? this.$options.name : 'App'
      return this.logger[level]( format, comp, ...args)
    },
    setLogLevel(level) {
      this.logger.setLogWarnings(level)
    }
  }
}
